import { BudgetRequestAnalyticsTypeEnum } from '@zaoblako/shared/modules/task/enum/budget-request-analytics-type.enum';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link BudgetRequestAnalyticsTypeEnum} enumeration values */
export const BudgetRequestAnalyticsTypeEnumI18n: EnumI18nInterface<BudgetRequestAnalyticsTypeEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [BudgetRequestAnalyticsTypeEnum.PLAN]: 'План',
    [BudgetRequestAnalyticsTypeEnum.FACT_KASS]: 'Факт.Касса',
    [BudgetRequestAnalyticsTypeEnum.FACT_SALE]: 'Факт.Начисления',
  },
  [I18nLocalesEnum.EN_US]: {
    [BudgetRequestAnalyticsTypeEnum.PLAN]: 'Plan',
    [BudgetRequestAnalyticsTypeEnum.FACT_KASS]: 'Fact.Kass',
    [BudgetRequestAnalyticsTypeEnum.FACT_SALE]: 'Fact.Sale',
  },
};
